"use client"

import React, { useEffect, useRef } from "react"
import { Link, useLocation } from "react-router-dom"
import Banner from "../../banner/index"
import { User } from "lucide-react"
import { useSelector } from "react-redux"

import { useCart } from "../../../context/CartContext"

const Header = () => {
  const location = useLocation()
  const user = useSelector((state) => state.auth.user)
  const { cartLength } = useCart()
  const isHomePage = location.pathname === "/"
  const isUserProfilePage = location.pathname === "/user-profile"

  // Create a ref for the navbar toggler and collapse element
  const navbarTogglerRef = useRef(null)
  const navbarCollapseRef = useRef(null)

  // Track previous location to detect changes
  const prevLocationRef = useRef(location.pathname)

  // Auto-close the mobile drawer when route changes
  useEffect(() => {
    // Check if the location actually changed
    if (prevLocationRef.current !== location.pathname) {
      // Close the navbar if it's open
      if (window.innerWidth < 992) { // Bootstrap's lg breakpoint
        if (navbarCollapseRef.current && navbarCollapseRef.current.classList.contains('show')) {
          // Using Bootstrap's jQuery method if available
          if (window.$ && window.$.fn.collapse) {
            window.$(navbarCollapseRef.current).collapse('hide');
          } else {
            // Manual approach as fallback
            if (navbarTogglerRef.current) {
              navbarTogglerRef.current.click();
            }
          }
        }
      }

      // Update the previous location reference
      prevLocationRef.current = location.pathname;
    }
  }, [location.pathname]);

  // Function to handle link clicks and ensure drawer closes
  const handleLinkClick = () => {
    if (window.innerWidth < 992) { // Only for mobile view
      if (navbarCollapseRef.current && navbarCollapseRef.current.classList.contains('show')) {
        if (navbarTogglerRef.current) {
          navbarTogglerRef.current.click();
        }
      }
    }
  };

  // Function to check if a path is active (case insensitive)
  const isPathActive = (path) => {
    return location.pathname.toLowerCase() === path.toLowerCase()
  }
  const message = (
    <span style={{ color: 'black' }}>
      Hurry up! Get <span style={{ color: '#f83d8e', fontWeight: 'bold' }}>10% Discount</span> on all our products! &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    </span>
  );

  const repeatedText = Array(20).fill(message);

  return (
    <>
      <div
        style={{
          width: '100%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          position: 'relative',
          background: '#fff',
        }}
      >
        {/* Inline keyframes */}
        <style>
          {`
          @keyframes scrollLeft {
            0% { transform: translateX(0%); }
            100% { transform: translateX(-50%); }
          }
        `}
        </style>

        <div
          style={{
            display: 'inline-block',
            whiteSpace: 'nowrap',
            animation: 'scrollLeft 95s linear infinite',
          }}
        >
          {/* Repeat content twice to create a seamless loop */}
          <div style={{ display: 'inline-block' }}>
            {repeatedText}
          </div>
          <div style={{ display: 'inline-block' }}>
            {repeatedText}
          </div>
        </div>
      </div>
      <hr style={{ margin: "0" }} />
      <div className={isHomePage ? "home1_banner_outer position-relative" : "sub_banner_outer position-relative"}>
        <header className={`header ${isUserProfilePage ? "header-shadow" : ""}`}>
          <div className="container">
            <nav className="navbar navbar-expand-lg navbar-light p-0">
              <Link to="/" className="navbar-brand" onClick={handleLinkClick}>
                <figure className="logo mb-0">
                  <img
                    src="/logo.png"
                    alt="Logo-0"
                    className="img-fluid"
                  />
                </figure>
              </Link>
              <div className="mobile-user-drawer-alignment">
                {/* Cart link - Only visible on mobile */}
                <Link to="/cart" className="text-decoration-none cart icon position-relative d-lg-none" onClick={handleLinkClick}>
                  <img src="./assets/images/header-cart.png" alt="Cart-0" className="img-fluid" />
                  <span className="cart-count-mobile-view">{cartLength}</span>
                </Link>
                <div className="d-lg-none">
                  {user ? (
                    // User is logged in, show dummy image
                    <Link
                      to="/user-profile"
                      className="text-decoration-none cart icon position-relative"
                      aria-label="User Profile"
                      onClick={handleLinkClick}
                    >
                      <img
                        src={user.userImage}
                        alt="User Profile"
                        className="img-fluid rounded-circle"
                        style={{ width: "40px", height: "40px", objectFit: "cover" }}
                      />
                    </Link>
                  ) : (
                    // User is not logged in, show user icon
                    <Link
                      to="/login"
                      className="text-decoration-none cart icon position-relative"
                      aria-label="User Profile"
                      onClick={handleLinkClick}
                    >
                      <User style={{ color: "rgb(73, 72, 72)" }} size={25} />
                    </Link>
                  )}
                </div>
                <button
                  className="navbar-toggler collapsed"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  ref={navbarTogglerRef}
                >
                  <span className="navbar-toggler-icon"></span>
                  <span className="navbar-toggler-icon"></span>
                  <span className="navbar-toggler-icon"></span>
                </button>
              </div>

              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
                ref={navbarCollapseRef}
              >
                <ul className="navbar-nav mx-auto">
                  <li className={`nav-item dropdown ${isPathActive("/") ? "active" : ""}`}>
                    <Link to="/" className="nav-link navbar-text-color" onClick={handleLinkClick}>
                      Home
                    </Link>
                  </li>
                  <li className={`nav-item ${isPathActive("/lollipops") ? "active" : ""}`}>
                    <Link to="/lollipops" className="nav-link" onClick={handleLinkClick}>
                      Lollipops
                    </Link>
                  </li>
                  <li className={`nav-item dropdown ${isPathActive("/candies") ? "active" : ""}`}>
                    <Link to="/candies" className="nav-link dropdown-color navbar-text-color" onClick={handleLinkClick}>
                      Candies
                    </Link>
                  </li>
                  <li className={`nav-item ${isPathActive("/toffees") ? "active" : ""}  `}>
                    <Link to="/toffees" className="nav-link navbar-text-color" onClick={handleLinkClick}>
                      Toffees/Eclair's
                    </Link>
                  </li>
                  <li className={`nav-item ${isPathActive("/premia") ? "active" : ""}`}>
                    <Link to="/premia" className="nav-link navbar-text-color" onClick={handleLinkClick}>
                      Premia
                    </Link>
                  </li>
                  {/* <li className={`nav-item ${isPathActive("/diwali-special-combo") ? "active" : ""}`}>
                    <Link
                      to="/diwali-special-combo"
                      className="nav-link navbar-text-color"
                      onClick={handleLinkClick}
                    >
                      Diwali Special Combo
                    </Link>
                  </li> */}

                  <li className={`nav-item ${isPathActive("/contact") ? "active" : ""}`}>
                    <Link to="/contact" className="nav-link" onClick={handleLinkClick}>
                      Contact Us
                    </Link>
                  </li>
                </ul>
                <div className="last_list">
                  {/* Desktop-only cart */}
                  <Link to="/cart" className="text-decoration-none cart icon position-relative d-none d-lg-inline-block" onClick={handleLinkClick}>
                    <img src="./assets/images/header-cart.png" alt="Cart-0" className="img-fluid" />
                    <span>{cartLength}</span>
                  </Link>

                  {user ? (
                    <Link
                      to="/user-profile"
                      className="text-decoration-none cart icon position-relative"
                      aria-label="User Profile"
                      onClick={handleLinkClick}
                    >
                      {user.userImage ? (
                        <img
                          src={user.userImage}
                          alt="User Profile"
                          className="img-fluid rounded-circle"
                          style={{ width: "40px", height: "40px", objectFit: "cover" }}
                        />
                      ) : (
                        <User style={{ color: "rgb(73, 72, 72)" }} size={25} />
                      )}
                    </Link>
                  ) : (
                    <Link
                      to="/login"
                      className="text-decoration-none cart icon position-relative"
                      aria-label="User Profile"
                      onClick={handleLinkClick}
                    >
                      <User style={{ color: "rgb(73, 72, 72)" }} size={25} />
                    </Link>
                  )}

                  <Link to="/contact" className="text-decoration-none contact_us" onClick={handleLinkClick}>
                    Contact Us
                    <i className="fa-solid fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </nav>
          </div>
        </header>
        <div id="search" className="">
          <span className="close">X</span>
          <form role="search" id="searchform" method="get">
            <input value="" name="q" type="search" placeholder="Type to Search" />
          </form>
        </div>
        {isHomePage && <Banner />}
      </div>

      {/* Add this CSS to your component or stylesheet */}
      <style jsx>{`
        .header-shadow {
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
        }
      `}</style>
    </>
  )
}

export default Header